import { Link, Outlet } from 'react-router-dom';
import { SafeArea } from '../../shared';
import ScrollToTop from '../../shared/scrollToTop';
import { IsMobileDevice } from '../../utils';
import { ReactComponent as AppQrCode } from "../../assets/images/appQrCode.svg";
import CacheService from './cacheService';
import { Helmet } from 'react-helmet-async';
import { useMyContext } from '../../entities/context';
import { message } from 'antd';


const MainLayout: React.FC = () => {
    const { topHeight } = useMyContext();
    message.config({ top: Number(topHeight) })
    return <div style={{ backgroundColor: 'var(--secondarys200)' }}>
        <SafeArea />
        <Helmet>
            <meta name="robots" content="noindex, nofollow" />
        </Helmet>
        <div style={{ maxWidth: "480px", marginInline: "auto", backgroundColor: 'var(--basewhite)', width: "auto" }}>
            <ScrollToTop />
            <Outlet />
        </div>
        {!IsMobileDevice()
            ? <div style={{ display: 'flex', flexDirection: 'column', gap: '23px', backgroundColor: '#FFFFFF', position: 'fixed', top: '50%', left: 'calc(50% + 240px + 34px)', width: '204px', height: '301px', borderRadius: '8px', padding: '24px' }}>
                <AppQrCode width={140} height={140} />
                <div>
                    <div style={{ fontWeight: '700', lineHeight: '33.6px', textAlign: 'left', fontSize: '24px', paddingBottom: '12px' }}>
                        파지티브호텔 앱에서<br />
                        쉽고 편한 수업 예약을<br />
                        시작해보세요.</div>
                    <div className='body/b2 secondary/s600'>QR코드를 스캔해보세요</div>
                </div>
            </div>
            : <CacheService />}
        {/* {!IsMobileDevice()
            && <div style={{ display: 'flex', flexDirection: 'column', gap: '23px', backgroundColor: '#FFFFFF', position: 'fixed', top: '80%', left: 'calc(50% + 240px + 34px)', borderRadius: '8px', padding: '24px' }}>
                <div>
                    <div style={{ fontWeight: '700', lineHeight: '33.6px', textAlign: 'left', fontSize: '20px', paddingBottom: '6px' }}>
                        Company info
                    </div>
                    <div style={{ fontSize: '12px', lineHeight: '20px' }}>
                        <div style={{ paddingBottom: '6px' }}>
                            파지티브호텔 요가 선릉 | 정형록<br />

                            서울특별시 강남구 도산대로 311, 6층(신사동)<br />
                            서울특별시 강남구 테헤란로 407, 1층 일부(삼성동)<br />

                            사업자 등록번호 113-85-42244<br />

                            이메일 positivehotelyoga@positivehotel.com<br />
                        </div>
                        <div>
                            <Link to={'/serviceUseTerm'} style={{ textDecorationLine: 'none' }}>Terms of Service</Link>
                            &nbsp;|&nbsp;
                            <Link to={'/personInfoPolicy'} style={{ textDecorationLine: 'none' }}>Privacy Policy</Link>
                        </div>
                    </div>
                </div>
            </div>} */}
    </div>;
};

export default MainLayout;